import { enumUtil } from '@/utils';

const RegimeTributarioEnumerator = Object.freeze({
  None: new enumUtil.EnumBase(0, ''),
  Simples: new enumUtil.EnumBase(1, 'Simples Nacional'),
  SimplesExcessoSublimite: new enumUtil.EnumBase(2, 'Simples Nacional, excesso sublimite de receita bruta'),
  Normal: new enumUtil.EnumBase(3, 'Regime Normal'),
});

const ResponsavelTecnicoEnumerator = Object.freeze({
  None: new enumUtil.EnumBase(0, ''),
  VrTech: new enumUtil.EnumBase(1, 'VR Tech'),
  Partner: new enumUtil.EnumBase(2, 'Partner'),
  Personalizado: new enumUtil.EnumBase(3, 'Personalizado'),
});

const TipoGradeEixoEnumerator = Object.freeze({
  Tamanho: new enumUtil.EnumBase(0, 'Tamanho'),
  Cor: new enumUtil.EnumBase(1, 'Cor'),
});

export { RegimeTributarioEnumerator, ResponsavelTecnicoEnumerator, TipoGradeEixoEnumerator };
